import {
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  useTheme,
} from "@mui/material";
import { SiteAnchorVisual } from "../../../visuals/SiteAnchorVisual";
import { WorldRenderer } from "../../WorldRenderer";
import { CenterFocusStrong } from "@mui/icons-material";
import { useNavigate } from "react-router";
import { toVector3 } from "../../../visuals/visual-utils";
import { RenderAccordionToolbar } from "../../../components/Minibar";

export function SiteList({
  wr,
  sites,
  pinned,
  panel,
  togglePin,
}: {
  wr: WorldRenderer;
  sites: SiteAnchorVisual[];
  pinned: Set<string>;
  panel: string;
  togglePin: (panel: string) => void;
}) {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <>
      <RenderAccordionToolbar
        pinned={pinned}
        panel={panel}
        togglePin={togglePin}
      />
      <List>
        {sites.map((site) => (
          <ListItem key={site._id} disablePadding dense>
            <ListItemButton onClick={() => navigate(`/sites/${site._id}`)}>
              <ListItemText primary={site.id || site.mgrs} />
            </ListItemButton>
            <ListItemIcon sx={{ minWidth: "0px" }}>
              <Tooltip title="View" placement="top">
                <IconButton
                  size="small"
                  onClick={async () => {
                    const cameraPos1 = wr.planetService.getCameraPosition(
                      site.location,
                      20000
                    );
                    wr.camera.up = toVector3(cameraPos1.up);
                    wr.cameraControls.updateCameraUp();
                    await wr.cameraControls.setLookAt(
                      cameraPos1.position.x,
                      cameraPos1.position.y,
                      cameraPos1.position.z,
                      cameraPos1.target.x,
                      cameraPos1.target.y,
                      cameraPos1.target.z,
                      true
                    );
                    const cameraPos2 = wr.planetService.getCameraPosition(
                      site.location,
                      300
                    );
                    wr.camera.up = toVector3(cameraPos2.up);
                    wr.cameraControls.updateCameraUp();
                    await wr.cameraControls.setLookAt(
                      cameraPos2.position.x,
                      cameraPos2.position.y,
                      cameraPos2.position.z,
                      cameraPos2.target.x,
                      cameraPos2.target.y,
                      cameraPos2.target.z,
                      true
                    );
                  }}
                >
                  <CenterFocusStrong fontSize="small" />
                </IconButton>
              </Tooltip>
            </ListItemIcon>
          </ListItem>
        ))}
      </List>
    </>
  );
}
